module.exports = __webpack_public_path__ + "img/heroIndex2.258d6ce0.png";